import { render, staticRenderFns } from "./CustomMethod.vue?vue&type=template&id=1ce50738&scoped=true&lang=pug"
import script from "./CustomMethod.vue?vue&type=script&lang=js"
export * from "./CustomMethod.vue?vue&type=script&lang=js"
import style0 from "./CustomMethod.vue?vue&type=style&index=0&id=1ce50738&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce50738",
  null
  
)

export default component.exports